import React from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '../../context';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser as faUserOutline } from '@fortawesome/free-regular-svg-icons';
import { faUser } from '@fortawesome/free-solid-svg-icons';

const UserAssignment = ({
    practiceId,
    practiceName = '',
    assignedAccountInitials = '',
    assignedAccountId = null,
    isAssignedToCurrentUser = false,
}) => {
    const dispatch = useDispatch();

    const openAssignmentModal = () => {
        const payload = {
            id: practiceId,
            name: practiceName,
            assignedAccountId,
            isAssignedToCurrentUser,
        };
        dispatch(actions.practice.selectPracticeToAssignToUser(payload));
        dispatch(actions.toggle.toggleAssignUserToPracticeModal(true));
    };

    return (
        <div
            className={classNames('text-nowrap', {
                'hover-child': !assignedAccountId,
            })}
            onClick={openAssignmentModal}>
            <span>
                <FontAwesomeIcon
                    className="pop-hover text-light"
                    icon={assignedAccountId ? faUser : faUserOutline}
                />
                {assignedAccountId && (
                    <span className="hide-overflow">
                        &nbsp;&nbsp;
                        {assignedAccountId !== null
                            ? assignedAccountInitials.substring(
                                  0,
                                  assignedAccountInitials.indexOf(' ')
                              )
                            : ``}
                    </span>
                )}
            </span>
        </div>
    );
};

export default UserAssignment;
